<template>
  <el-savitarna-alert dense outlined type="info" v-if="enableTooltip">
    <span class="tooltip-santrauka" v-html="tooltipTekstas"></span>
  </el-savitarna-alert>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ElPaslaugaSantrauka',
  props: {
    tooltip: String,
  },
  data() {
    return {
      // showTooltip: false,
    }
  },
  computed: {
    ...mapGetters(['infoTooltips']),
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop' ||
        process.env.VUE_APP_LOCAL === 'test'
      )
    },
    showEmpty() {
      return this.tooltip && this.isLocal
    },
    enableTooltip() {
      return (
        (this.tooltipTekstas !== '' && this.tooltipItem.too_aktyvus === true) ||
        this.showEmpty
      )
    },
    tooltipItem() {
      return (
        this.infoTooltips.find(item => item.too_kodas === this.tooltip) ?? {}
      )
    },
    tooltipTekstas() {
      return this.tooltipItem.too_tekstas
        ? this.tooltipItem.too_tekstas
        : this.showEmpty
        ? this.tooltip
        : ''
    },
    showTooltip() {
      return this.tooltip
    },
  },
}
</script>
<style lang="scss" scoped>
.tooltip-santrauka p {
  margin-bottom: 3px;
}
</style>
